import { Allocation, StrategyProvider } from '@ndvr/portfolio-api';

export const isBlackrockAllocation = (allocation: Pick<Allocation, 'provider'>): boolean =>
    allocation.provider === StrategyProvider.BLACKROCK;
